// eslint-disable-next-line no-shadow
export enum StorageKeys {
  newUser = 'newUser',
  hasAppPreviouslyOpen = 'hasAppPreviouslyOpen',
  deviceUUId = 'deviceUUId',
  loginToken = '@login_token',
  wToken = '@wToken',
  retryConfig = 'retryConfig',
  FileUploadData = 'FileUploadData',
  vanLoadCoachmarkShown = 'vanLoadCoachmarkShown',
  user = '@user',
  secondLogLocation = 'secondLogLocation',
  BLEDevice = 'BLEDevice',
  onfleetPhoneNumber = 'onFleetPhoneNumber',
  onfleetPhoneNumberPrefix = 'onfleetPhoneNumberPrefix',
  onfleetPassword = 'onfleetPassword',
  lastDropItemTime = 'lastDropItemTime',
  loggingDelay = 'loggingDelay',
  permissionModal = 'permissionModal',
  meijerDebug = 'meijerDebug',
  smartLookEnabled = 'smartLookEnabled',
  isB2BFlow = 'isB2BFlow',
  localizationModuleData = 'localizationModuleData',
  localizationModuleVersion = 'localizationModuleVersion',
  appVersion = 'appVersion',
  locateCoachmarkShown = 'locateCoachmarkShown',
  deliveryTimestamps = 'deliveryTimestamps',
  snoozeTimer = 'snoozeTimer',
  snoozedItems = 'snoozedItems',
}
